
import { defineComponent, ref, computed } from "vue";
import { InviteUtils } from '@/utils/InviteUtils';
import { GameUtils } from "@/utils/GameUtils";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useMeta } from "vue-meta";
import { User } from '@/_models/User';
import { UserService } from "@/services/UserService";
import defaultImage from "@/assets/images/user.png";
import router from "@/router";

export default defineComponent({
  name: "viewDeveloperProfile",
  setup() {
    let totalGames;
    const pages = ref(20);
    const currentPage = ref(1);
    const totalPages = ref(0);
    const route = useRoute()
    const store = useStore();
    const userObj = store.getters['auth/user'];
    const label = computed(() => {
      return store.getters['config/configLabel'];
    });
    const metaTitle = ref('MetaXar Developer Profile');
    const metaDescription = ref('MetaXar Developer Profile Description');
    useMeta({ title: metaTitle.value, description: metaDescription.value });
    const developerName = ref('');
    const developerTag = ref('');
    const dateJoined = ref('Jul. 14,2018');
    const dateVerified = ref('Jan. 03,2019');
    const contentRating = ref('12+');
    const Plays = ref('12,293');
    const publisher = ref('');
    const launchedGames = ref('5');
    const runningGames = ref('5');
    const games = ref([]);
    const displayGames = ref([]);
    const displayPopularGames = ref([]);
    const invitedGames = ref([]);
    const popularGames = ref([]);
    const favouritesCount = ref([]);
    const publishedGames = ref([]);
    const assetURL = computed(() => {
      return store.getters['config/assetUrl'];
    });
    const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const image = ref(defaultImage);


    (async () => {
      const userService = new UserService();
      const userDetail: User = await userService.getUser(route.params.developerId.toString());
      if(!userDetail) {
        router.push('/invalid-developer-id');
      }
      // console.log(userDetail);
      const updated = new Date(userDetail.xarcadeUser.created);
      const updatedDate = month[(updated.getMonth() + 1)] + '. ' + ("0" + updated.getDate()).slice(-2) + ',' + updated.getFullYear();
      if(userDetail.xarcadeUser.profilePicture){
        image.value = assetURL.value + 'blob/users/' + userDetail.xarcadeUser.username + '/' + userDetail.xarcadeUser.profilePicture; 
      }
      dateJoined.value = updatedDate;
      developerTag.value = userDetail.xarcadeUser.email;
      publisher.value = userDetail.xarcadeUser.company;
      developerName.value = userDetail.xarcadeUser.username;

      popularGames.value = await GameUtils.fetchDeveloperPopularityCount(route.params.developerId.toString());

      const nestedSort = (prop1, prop2 = null, direction = 'asc') => (e1, e2) => {
        const a = prop2 ? e1[prop1][prop2] : e1[prop1],
            b = prop2 ? e2[prop1][prop2] : e2[prop1],
            sortOrder = direction === "asc" ? 1 : -1
        return (a < b) ? -sortOrder : (a > b) ? sortOrder : 0;
    }

      const sortedPopular = popularGames.value.sort(nestedSort("popularityCount", null, "desc"))
      displayPopularGames.value = sortedPopular;



      publishedGames.value = await GameUtils.fetchDeveloperPublishedGame(route.params.developerId.toString());
      totalGames = publishedGames.value.length;
      totalPages.value = Math.ceil(totalGames / pages.value);
      displayGames.value = publishedGames.value.slice(
        (currentPage.value - 1) * pages.value,
        Number((currentPage.value - 1) * pages.value) + Number(pages.value));
        launchedGames.value = publishedGames.value.length.toString();

    })()

    const loadGames = () => {
      totalPages.value = Math.ceil(games.value.length / pages.value);
      displayGames.value = publishedGames.value.slice(
        (currentPage.value - 1) * pages.value,
        Number((currentPage.value - 1) * pages.value) + Number(pages.value)
      );
    };
    loadGames();

    const enableFirstPage = computed(() => {
      return currentPage.value > 1;
    });

    const enablePreviousPage = computed(() => {
      return currentPage.value > 1;
    });

    const enableNextPage = computed(() => {
      return totalPages.value - currentPage.value > 0;
    });

    const enableLastPage = computed(() => {
      return currentPage.value < totalPages.value;
    });

    const naviFirst = () => {
      currentPage.value = 1;
      loadGames();
    };

    const naviPrevious = () => {
      --currentPage.value;
      loadGames();
    };

    const naviNext = () => {
      ++currentPage.value;
      loadGames();
    };

    const naviLast = () => {
      currentPage.value = totalPages.value;
      loadGames();
    };

    const changeRows = () => {
      loadGames();
    };



    return {
      image,
      developerName,
      developerTag,
      dateJoined,
      dateVerified,
      contentRating,
      Plays,
      publisher,
      launchedGames,
      runningGames,
      games,
      label,
      assetURL,
      displayGames,
      displayPopularGames,
      publishedGames,
      invitedGames,
      pages,
      currentPage,
      totalPages,
      enableFirstPage,
      enablePreviousPage,
      enableNextPage,
      enableLastPage,
      naviFirst,
      naviPrevious,
      naviNext,
      naviLast,
      changeRows,
    }
  }
});
